module.exports = __webpack_public_path__ + "static/media/profile.ac37a9cc.jpg";